module.exports = __webpack_public_path__ + "static/media/mandi.31768a30.png";